import { WalletGatedButton, DialogAwareContentContainer, DialogAwareButtonContainer, TokenInput } from "@/components";
import { useStakingPosition, useWithdrawForm } from "@/hooks";
import { TOKEN_IDS } from "@/types";

interface WithdrawFormProps {
    isLoading?: boolean;
    isDialog?: boolean;
}

export function WithdrawForm({ isLoading, isDialog }: WithdrawFormProps) {
    const { stakingPosition } = useStakingPosition();
    const { withdrawAmount, withdrawAmountError, submitWithdraw, setMaxAmount, isAmountOverBalance } =
        useWithdrawForm();

    const handleSubmit = submitWithdraw;
    const handleMaxClick = setMaxAmount;

    return (
        <form onSubmit={handleSubmit} className="w-[480px] max-w-full">
            <DialogAwareContentContainer isDialog={isDialog} className="space-y-4">
                <TokenInput
                    amount={withdrawAmount}
                    amountError={withdrawAmountError}
                    selectedTokenId={TOKEN_IDS.IUSD}
                    handleTokenSelect={() => {}}
                    handleMaxClick={handleMaxClick}
                    tokenOptions={[TOKEN_IDS.IUSD]}
                    label="Enter withdrawal amount"
                    walletBalanceOverride={{
                        amount: stakingPosition.stakedBalance,
                        balancePrefix: "Staked balance: ",
                    }}
                    isMaxDisabled={
                        !stakingPosition.stakedBalance || stakingPosition.stakedBalance === "0" || isAmountOverBalance
                    }
                />
            </DialogAwareContentContainer>

            <DialogAwareButtonContainer isDialog={isDialog}>
                <WalletGatedButton
                    className="py-2.5 text-lg"
                    type="submit"
                    isLoading={isLoading}
                    disabled={
                        !stakingPosition.stakedBalance || stakingPosition.stakedBalance === "0" || isAmountOverBalance
                    }
                    fullWidth
                    variant="primary"
                    color="primary"
                >
                    Withdraw
                </WalletGatedButton>
            </DialogAwareButtonContainer>
        </form>
    );
}
